import React from 'react';
import { useTranslation } from 'react-i18next';
import GearIcon from 'assets/images/icons/gear-filled.svg?react';
import { PropertyActionsDropdownButtonStyled } from './PropertyListItem.styles';

const PropertyActionsDropdown = ({
  propertyUid,
  children,
}: {
  propertyUid: string;
  children: React.ReactNode;
}) => {
  const { t } = useTranslation();

  return (
    <div id={`property-actions-container-${propertyUid}`}>
      <PropertyActionsDropdownButtonStyled
        aria-label={t('pageProperties.actions.propertyActionsMenu')}
        data-testid="property-actions-menu"
        id="property-actions"
        title={<GearIcon />}
        bsStyle="default"
        bsSize="xsmall"
        noCaret
        pullRight
      >
        {children}
      </PropertyActionsDropdownButtonStyled>
    </div>
  );
};

export default PropertyActionsDropdown;
